// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"49538003","225":"8f83a600","354":"1aba215b","418":"81b49044"}[chunkId] + ".js";
};